
export const state = {

}
export const getters = {

}

export const actions = {
    populateFromDB: ({commit, state, dispatch}) =>{
      // Called on refresh for collaborative editor module   
    }
}

export const mutations = {

}
